import React from 'react';
import Helmet from "react-helmet";
import {Card, CardGroup, Row, Col} from 'react-bootstrap';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';

import speaker from "../../assets/images/contents/DrUzirMahidin.jpg"

export const DatoSriDrUzirMahidin = () => (
  <div>
    <Helmet>
      <title>The 7th International Conference on Soft Computing in Data Science 2022 (scds2023) - Keynote Speaker</title>
    </Helmet>
    <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">DatoSriDrUzirMahidin</li>
      </ol>
    </nav>
    {/* <h2>Abstract - Professor Dr. Richard C Millham</h2> <br/>   */}

    <Container> 
      <Row className="justify-content-md-center">  
        <Col md="auto">
          <Card>
            <Card.Img width="100px" height="220px" src={speaker} alt="speaker image" /> 
          </Card>             
        </Col>
      </Row>
    </Container>

    <p style={{textAlign:'center'}}>
      <b>YBhg Dato’ Sri Mohd Dr. Uzir Mahidin</b>
    </p>

    <p style={{textAlign:'center'}}>
      Chief Statistician Malaysia
    </p>

    <br/>

    <h4 style={{textAlign:'center'}}>Managing Multiple Data Sources for Analytics in Assisting the Government’s Policy Formulation</h4>

    <p style={{ textAlign:'justify'}}><b>Abstract</b><br/>
        The rise of Multiple Data Sources data usage from databases, website data, and satellite images make the Department of Statistics Malaysia (DOSM) a national statistics 
        provider to produce complementary statistics to assist the government’s policy formulation. A few years back, DOSM started the implementation of Big Data Analytics (BDA) 
        to enhance reliability and timeliness of official statistics. This speech will share the strategy of DOSM in Managing Multiple Data Sources for Analytics in assisting the 
        Policy Formulation in Malaysia.
    </p>

    <p style={{ textAlign:'justify'}}><b>Biography</b><br/>
        As a Chief Statistician of the Department of Statistics Malaysia (DOSM), effective February 14, 2017, he has been devoted to his career by serving at DOSM for the past 
        30 years since his first posting as a Statistician in 1990. He has an extensive experience and specialize in both economic and social statistics where he has served and 
        contributed in various fields of statistics such as national accounts; external trade; industrial & construction; and services. His career has spanned domestically as head 
        of national statistical office, Executive Committee of Institute Statistics Malaysia, Chairman of the Working Group on Statistical Database and the Chairman of the National 
        Organizing Committee of ISI World Statistics Congress 2019. In 2020, he was honoured with 2020 Congress of Unions of Employees in the Public and Civil Services (CUEPACS) 
        Malaysia Labour Day Icon Award. Recently, appointed as the Sixth Census Commissioner by His Majesty the Yang Di-Pertuan Agong XVI, Al-Sultan Abdullah Ri'ayatuddin Al-Mustafa 
        Billah Shah on 1st April 2020.
    </p>

    <p style={{ textAlign:'justify'}}>
        His active participation and significant contribution at the international arena is acknowledged through his appointment as the Chair of the Bureau of the Committee on 
        Statistics of the United Nations Economic and Social Commission for Asia and the Pacific (ESCAP) 2018-2020; Chair of Bureau for the 7th & 8th Sessions of Organization of 
        Islamic Cooperation Statistical Commission (OIC-StatCom) 2018-2019; Executive Committee of International Association of Official Statistics (IAOS) for two consecutive 
        terms 2017-2019 & 2020-2022; Co-Chair Working Group (WG) on the Development of New Strategic Vision of OIC-StatCom; and most recently, he is re-appointed as vice-chair 
        of the 7th Bureau of the ESCAP Committee on Statistics, 2020- 2022 terms.
    </p>

    <p style={{ textAlign:'justify'}}>
        He is also a member of various expert groups globally as well as international associations such as the ASEAN Community Statistical System (ACSS), UNWTO Tourism Statistics; 
        Expert Group on Civil Registration and Vital Statistics (CRVS) ESCAP; Member of Friends of Chair Fundamental Principles of Official Statistics (FOC-FPOS) United Nations; 
        High-Level Group for Partnership, Coordination and CapacityBuilding for Monitoring Sustainable Goals (SDG); and the ASEAN Secretariat on SNA Statistics, ISI-South East 
        Asia Network, Regional Programme on Economic Statistics and so on.
    </p>

    <p style={{ textAlign:'justify'}}>
      He is also a member of various expert groups globally as well as international associations such as the ASEAN Community Statistical System (ACSS), UNWTO Tourism 
      Statistics; Expert Group on Civil Registration and Vital Statistics (CRVS) ESCAP; Member of Friends of Chair Fundamental Principles of Official Statistics 
      (FOC-FPOS) United Nations; High-Level Group for Partnership, Coordination and CapacityBuilding for Monitoring Sustainable Goals (SDG); and the ASEAN Secretariat 
      on SNA Statistics, ISI-South East Asia Network, Regional Programme on Economic Statistics and so on.
    </p>

    <p style={{ textAlign:'justify'}}>Click this <b><a href = "https://www.iaos-isi.org/index.php/executive-committee-members-2017-2019/201-mohd-uzir-mahidin-member" target="_blank">link</a></b> to see his further detail bio.<br/></p>

    {/* <p>Click this <a href = "https://www.iaos-isi.org/index.php/executive-committee-members-2017-2019/201-mohd-uzir-mahidin-member" target="_blank" rel="noreferrer">link</a> to see his further detail bio. <br/>
    </p> */}

  </div>
)